import { render } from "./ExpansionPanelHeader.vue?vue&type=template&id=3e810bb1"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__